export enum ApiResponseStatus {
  SUCCESS = 'success',
  ERROR = 'error'
}
